/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], () => {
	class VisRecommenderUtils {

		/**
		 * Build a list of smart service chart types that dashboard supports
		 * @param {Array<VisDefinitionAPI>} visDefinitions VisDefinitionAPI's
		 * @returns {Array<String>} Smart service chart types supported by dashboard
		 */
		static buildChartTypes(visDefinitions) {
			let chartTypes = [];
			if (!visDefinitions) {
				return chartTypes;
			}

			chartTypes = visDefinitions.map(visDefinition => visDefinition.getType());
			chartTypes.push('ClusteredBar', 'ClusteredColumn', 'ClusteredLine', 'ClusteredPoint', 'HierarchicalPie', 'StackedArea');

			return chartTypes;
		}
	}

	return VisRecommenderUtils;
});
